module.exports = __webpack_public_path__ + "static/media/cargobattalaionone.2b40bf18.png";